module.exports = __webpack_public_path__ + "img/json_evo.0c45fbf7.png";